module.exports = "<div class=day-content> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/calendar.main/calendar.day/calendar.day.html
// module id = 4946
// module chunks = 50